// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"_8sRu9","rc-tabs-tab-active":"hs-0z","input-suffix":"Tnoo+","nav-item":"ZgFHt","container":"_2036s","content":"YPL4q","navigation":"kNL2L","card-item":"_6ZrQE"};